





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import DepositCoolingOffSettingsEdit from '@/components/Products/Forms/Deposit/DepositCoolingOffSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'DepositCoolingOffSettingsEditDialog', components: { DepositCoolingOffSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    get productType() {
        return ProductDetailsModule.product.generalSettings.subType;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editDepositCoolingOffSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
